import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithDocs_1 from '../../../../../libraries/Images/createAConnectionWithDocs_1.png';
import createAConnectionWithDocs_2 from '../../../../../libraries/Images/createAConnectionWithDocs_2.png';
import createAConnectionWithDocs_3 from '../../../../../libraries/Images/createAConnectionWithDocs_3.png';
import createAConnectionWithDocs_4 from '../../../../../libraries/Images/createAConnectionWithDocs_4.png';
import createAConnectionWithDocs_5 from '../../../../../libraries/Images/createAConnectionWithDocs_5.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithdocs">
                1.&nbsp;{translate('createaconnectionwithdocs')}
            </Typography>
            <p>Nhấp vào "Thêm mới" để tạo kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_1} width="75%" />
            </Zoom>
            <p>Một danh sách các ứng dụng có thể được liên kết sẽ hiển thị, hãy chọn "Docs" trong số đó.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_2} width="75%" />
            </Zoom>
            <p>Khi bạn nhấp vào "Docs", màn hình lựa chọn tài khoản Google của người dùng sẽ được hiển thị. Vui lòng chọn một tài khoản để sử dụng cho kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Khi bạn chọn một tài khoản, "RPA CLOUD" sẽ yêu cầu quyền truy cập thay cho bạn. Đồng ý cấp quyền truy cập trên cho "RPA CLOUD" và nhấp vào "Cho phép".</p>
            <Zoom>
                <img src={createAConnectionWithDocs_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Bạn sẽ thấy 1 thẻ Docs sau khi kết nối được tạo thành công.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_5} width="50%"/>
            </Zoom>
            <p>Sử dụng <strong>Provider ID</strong> có trong thẻ này để thực hiện các bước trong Docs.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(Vi);